import React, { useState, useContext } from 'react'
import { Col, Row, Input, Button, message, Form, notification } from 'antd'
import './Login.css'
import { useNavigate } from 'react-router';
import axios from 'axios';
import { MailOutlined, LockOutlined } from '@ant-design/icons'
import { BaseUrl } from '../Constants/Constants';
import Context from '../../Context/context';

const Login = () => {
  const { dispatch } = useContext(Context);

  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [EmailStatus, setEmailStatus] = useState('');
  const [pwdStatus, setPwdStatus] = useState('');


  let url = window.location.href;
  let splittedUrl = url.split('/')[3];
  console.log(splittedUrl, "url")

  const openNotificationWithIconSuccess = (type) => {
    console.log('getsSuccess')
    api['success']({
      message: "Success!!!",
      description:
        type,
    });
  };

  const handleForgotPass = () => {
    navigate("/forgotpassword")
  }

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    // Email validation regex pattern
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(value);

    // Update email status based on validation
    setEmailStatus(isValidEmail ? 'success' : 'error');
  };
  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);

    // Password validation regex pattern
    const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/;
    const isValidPassword = passwordRegex.test(value);

    // Update password status based on validation
    setPwdStatus(isValidPassword ? 'success' : 'error');
    console.log(isValidPassword, "isValidPassword")
  };

  const openNotificationWithIconWarning = (type) => {
    api['warning']({
      message: "Warning!!!",
      description:
        type,
    });
  };

      const openNotificationWithIconError = (type) => {
      api['error']({
        message: "Login Failed",
        description:
          type,
      });
    };

  const handleLogin = () => {
    let Body = {
      "username": email,
      "password": password,
      "email": email.toLowerCase()
    }
    if (email && password && pwdStatus == "success") {
      axios
        .post(`${BaseUrl}auth/admin/login`, Body,{withCredentials: true})
        .then((res) => {
          if (res?.status === 200 && res?.data?.status === "SUCCESS") {
              openNotificationWithIconSuccess('Logged in Sucessfully')
              dispatch({ type: "SET_IS_LOGGED_IN", payload: true });
              dispatch({ type: "SET_EMPLOYEE", payload: res?.data?.data?.employee });

              localStorage.setItem("Profile", JSON.stringify(res?.data?.data?.employee));
              localStorage.setItem("companyId", res?.data?.data?.companyId);

              setTimeout(() => {
                if (res.data.newuser) {
                    navigate('/PasswordChange');
                } else {
                    navigate('/', { state: { message: 'Logged in Successfully' } });
                }
            }, 500);
          }else{
            openNotificationWithIconError(res?.data?.message?res?.data?.message:'Network issue detected. Please try again later.');
          }
        })
        .catch((err) => {
          openNotificationWithIconError(err?.response?.data?.message?err?.response?.data?.message:'Network issue detected. Please try again later.');
        })
    }
    else {
      openNotificationWithIconError('Please enter valid Credentials');
    }
  }

  const handleSignup = () => {
    navigate("/signup")
  }



  return (

    <div className='LoginImg'>
      {contextHolder}
      <Row className='LoginRow'>
        <Col
        style={{ display: 'flex', justifyContent: 'center' }}
       
        //  span={{ xs: 8, sm: 16, md: 24, lg: 12 }}
        >
          <div className='Login'>
            <div className='logindiv'>
              <div className='LogoDiv'>
                <img src='/Logo/Logo Svg OG 3.png' className='loginImage' alt='Logo' />

              </div>
              <p className='LoginH1'>
                Admin Portal
              </p>

              <Input
                prefix={<MailOutlined style={{ color: '#667eea' }} />}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    document.getElementById('passwordInputField').focus();
                  }
                }}
                className='loginInput'
                placeholder='Email ID'
                onChange={handleEmailChange}
                status={!email ? EmailStatus : ''}
              />
              <Form.Item className='PasswordForm' hasFeedback validateStatus={pwdStatus}>

                <Input.Password
                  id='passwordInputField'
                  prefix={<LockOutlined style={{ color: '#667eea' }} />}
                  onKeyDown={(e) => {
                    if (e.key == 'Enter') handleLogin();
                  }}
                  className='loginInput'
                  placeholder='Password'
                  type='password'
                  onChange={handlePasswordChange}
                  status={!password ? pwdStatus : ''}
                />
              </Form.Item>

              <div className='forgotpassDiv'>
              <Button
                onClick={handleForgotPass}
                className='forgotpassword' size='small' type='link'
              >
                Forgot Password?
              </Button>
            </div>


            </div>
            <div className='forgotpassDiv'>

              <Button
                onClick={handleLogin}
                className='signUpButton'>
                Login
              </Button>
            </div>
            <div>
              {/* <p className='ortag'>------------ or ------------</p> */}

              {/* <Button
                onClick={handleSignup}
                className='signUpButton'>
                Signup
              </Button> */}



            </div>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default Login